export default "https://assets.pclncdn.com/web/next-landing/bc028b7/_next/static/images/dallas-a729d06ad0b7fc9b3fdec23533a8a2da.jpg";